module.exports = __webpack_public_path__ + "static/media/henry-fly.b30208ef.jpg";